export const theme = {
  colors: {
    primary: '#B91B2E',
    primaryDark: '#9A1726',
    primaryLight: '#D84A5A',
    secondary: '#F2B48D',
    secondaryDark: '#E89F6F',
    secondaryLight: '#F7D0B5',
    tertiary: '#F6DFD9',
    tertiaryDark: '#E8C5BC',
    tertiaryLight: '#FBF0ED',
    background: '#FFFFFF',
    backgroundDark: '#F8F9FA',
    surface: '#F8F9FA',
    text: '#2C3E50',
    textLight: '#7F8C8D',
    textSecondary: '#7F8C8D',
    textDark: '#1A252F',
    success: '#2ECC71',
    error: '#E74C3C',
    warning: '#F39C12',
    border: '#E1E8ED',
    shadow: 'rgba(0, 0, 0, 0.1)',
  },
  fonts: {
    primary: "'Assistant', 'Heebo', 'Rubik', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    heading: "'Assistant', 'Heebo', 'Rubik', sans-serif",
  },
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  spacing: {
    xxs: '0.125rem',
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
    '3xl': '4rem',
  },
  breakpoints: {
    sm: '480px',
    mobile: '320px',
    md: '768px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1280px',
  },
  borderRadius: {
    sm: '0.25rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
    full: '9999px',
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
  },
  transitions: {
    fast: '150ms ease-in-out',
    normal: '250ms ease-in-out',
    slow: '350ms ease-in-out',
  },
  zIndex: {
    dropdown: 1000,
    sticky: 1020,
    fixed: 1030,
    modalBackdrop: 1040,
    modal: 1050,
    popover: 1060,
    tooltip: 1070,
  },
};

export type Theme = typeof theme;
